import { Stack } from 'expo-router';
import React from 'react';

export default function LeafletingRoundLayout() {
  return (
    <Stack>
      <Stack.Screen name="index" />
      <Stack.Screen name="[assignmentId]" />
    </Stack>
  );
}
